import { StandardEvents } from '@shopify/events';

const selector = '[data-sf-recommendation-policy]';
const requests = new WeakMap();
let timer;

async function refresh(root) {
  requests.get(root)?.abort();
  const controller = new AbortController();
  requests.set(root, controller);
  const url = new URL(location.href);
  url.searchParams.set('section_id', root.dataset.sectionId);
  url.searchParams.delete('page');
  try {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error('Recommendations unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const replacement = [...doc.querySelectorAll(selector)].find(node => node.dataset.sectionId === root.dataset.sectionId);
    if (!replacement || !root.isConnected) throw new Error('Recommendations unavailable');
    root.replaceChildren(...replacement.childNodes);
    root.hidden = replacement.hidden;
    root.bindCarousel?.();
  } catch (error) {
    if (error.name !== 'AbortError' && root.isConnected) root.hidden = true;
  } finally {
    if (requests.get(root) === controller) requests.delete(root);
  }
}

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(() => document.querySelectorAll(selector).forEach(refresh), 180);
}

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  document.querySelectorAll(selector).forEach(root => { root.hidden = true; });
  if (event.promise) event.promise.then(schedule, schedule);
  else schedule();
});
document.addEventListener('signature-frags:cart-add', schedule);
document.addEventListener('signature-frags:variant-change', schedule);
document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
